import React from 'react';
import { Tag } from 'antd';
import { styled } from 'styled-components';

export interface KeyboardShortcutProps {
  children: React.ReactNode;
}

const ShortcutTag = styled(Tag)`
  padding: 0.15rem 0.25rem;
  display: flex;
  align-items: center;
  height: 1.5rem;
`;

export const KeyboardShortcut: React.FC<KeyboardShortcutProps> = ({ children }) => {
  return <ShortcutTag data-type="KeyboardShortcut">{children}</ShortcutTag>;
};

export default KeyboardShortcut;
